import { Container, Layout } from '../../components/layout/';
import { GlobalPage } from '../../components/GlobalPage.jsx';
import { PersonalLoanReportForm } from '../../components/PersonalLoanReportForm/';

const allowedLoanTypes = ['credit_card', 'consumer'];

function sanitizeLoanType(loanType) {
  if (allowedLoanTypes.indexOf(loanType) === -1) {
    return null;
  }

  return loanType;
}

function sanitizeInterestRate(value) {
  if (!value) {
    return null;
  }

  value = Number((Number(value.replace(',', '.')) * 100).toFixed(0));

  return isNaN(value) ? null : value;
}

export default function IndexPage({ loanType, interestRate }) {
  return (
    <GlobalPage
      title="Forbrukslån: Best og billigst forbruks­lån"
      description="Vi sammenligner den reelle forbrukslån- og kredittkortrenten mellom alle bankene i landet. Ved å teste din egen rente, kan vi avdekke hvor mye du kan spare."
      canonical="/forbrukslan"
    >
      <Layout>
        <Container>
          <PersonalLoanReportForm
            firstLoanType={loanType}
            firstInterestRate={interestRate}
          />
        </Container>
      </Layout>
    </GlobalPage>
  );
}

IndexPage.getInitialProps = function({ query }) {
  const { loanType = null, interestRate = null } = query;

  return {
    loanType: sanitizeLoanType(loanType),
    interestRate: sanitizeInterestRate(interestRate),
  };
};
